import { render, staticRenderFns } from "./BancoDeCartasIC.vue?vue&type=template&id=37dd635e"
import script from "./BancoDeCartasIC.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasIC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports